// extracted by mini-css-extract-plugin
export default {"btnSubmitAnswer":"InputAnswer_btnSubmitAnswer__qsmWu","answerBox":"InputAnswer_answerBox__yzb6B"};